import { API } from '../../../config/api';
import { POST } from '../../../utils/apicalls';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../categoryManagement.css';

function Subcategory(props: any) {
    const [subcategoryData, setSubCategoryData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const filtersubCategoryData = async () => {
        try {
            setIsLoading(true);
            let obj = { category_id: Number(props?.id) }
            const api = API.FILTER_SUBCATEGORY;
            const response: any = await POST(api, obj);

            if (response?.data) {
                setSubCategoryData(response?.data); // Update subcategories
            } else {
                console.error("Data not available:", response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    // 👇 Call API on component mount or when props.id changes
    useEffect(() => {
        if (props?.id) {
            filtersubCategoryData();
        }
    }, [props?.id]);

    return (
        <div>
            <div className="category-container">
                <div className="category-wrapper">
                    <h1 className="category-title">Shop By Sub Category</h1>
                    <br />
                    <br />
                    {isLoading ? (
                        <p className="loading-text">Loading...</p>
                    ) : (
                        <div className="category-list">
                            {subcategoryData?.map((category: any, index: number) => (
                                <div key={index} className="category-card">
                                    <img
                                        src={category.SubcategoryImage}
                                        alt={category.SubcategoryTitle}
                                        className="category-image"
                                        onClick={() => navigate(`/subCategory/${category.id}`)}
                                    />
                                    <h2 className="category-name">{category.SubcategoryTitle}</h2>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Subcategory;
